import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Helmet } from 'react-helmet';
import Casestudyback from '../../../../Component/Casestudyback'
import Banner from "../../../../asset/images/insight/case_studies/banner-automating-qlik-to-databricks.webp"
import { Link } from 'react-router-dom';

export default function AutomatingQlik() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Helmet><meta charset="UTF-8" />
                <meta charset="UTF-8" />
                <title>Qlik-to-Databricks Migration: Automation & Real-Time Insights</title>
                <meta name="description" content="Discover how a financial services firm upgraded from Qlik to Databricks with a scalable migration strategy, real-time visibility & reduced manual intervention." />
                <link rel="canonical" href="/case-study/qlik-databricks-migration-automation" />
            </Helmet>

            <Box id="case-studies" className='section sec_bg new_cs' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={3} alignItems="top" justifyContent='center'>
                        <Grid item lg={10} md={10} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h3' className='subhead skblue al_center'>
                                    Success Stories
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Automating Qlik-to-Databricks Migration <span className='lower'>with</span> Real-Time Insights
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box>
                        <img loading="lazy" src={Banner} className='w100' alt='Banner' />
                    </Box>

                    <Box className='whitebx'>

                        <Box>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Client Overview
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                A leading US-based firm specializing in competitive intelligence and digital user experience research for financial institutions needed to transition from Qlik to a more scalable platform. With growing volumes of data and increasingly complex reporting needs, the organization aimed to modernize its infrastructure without compromising operational continuity or data accuracy.
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Problem Statement
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                The firm faced several operational challenges:
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Manual onboarding of historical and live data was slow and inefficient.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Complex validation processes caused frequent errors and lowered confidence in data quality.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Lack of real-time visibility across Qlik and servicer systems restricted oversight and responsiveness.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Managing multiple datasets, spanning loans and securities- demanded a more automated, unified solution.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                These issues hindered both internal productivity and service delivery.
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Solution Provided
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                Decimal Point Analytics implemented a comprehensive migration strategy leveraging Databricks’ unified analytics platform. Key components included:
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Automation of data ingestion and validation</strong> using Python and PySpark to eliminate manual errors.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Real-time monitoring</strong> across 26 mission-critical workflows to ensure full process visibility.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Seamless integration of daily data updates</strong> and merging of historical records for consistency.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>24/7 operational support</strong> to ensure continuous availability and performance during the transition.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                The approach provided an end-to-end framework for clean, timely, and scalable data delivery.
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Outcome
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                The engagement delivered measurable results:
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Reduced data onboarding time,</strong> accelerating access to insights.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Improved data integrity,</strong> enhancing trust and decision-making accuracy.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>24/7 process monitoring,</strong> enabling proactive intervention and fewer disruptions.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Lowered operational costs</strong> by removing manual dependencies and inefficiencies.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Established a scalable analytics foundation</strong> to support future growth initiatives.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Key Takeaway
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst mb0'>
                                For data-intensive organizations, automating migration workflows and embedding real-time visibility can drastically improve efficiency, scalability, and decision readiness.
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst mb0'>
                                Is your organization planning a data platform transformation?
                            </Typography>
                        </Box>

                        <Box>
                            <Typography variant='h6' className='black jst mb0'>
                                <Link to="/contact-us#contact_form" className="link">Connect with Decimal Point Analytics</Link> to explore how automation and 24/7 monitoring can power your next migration.
                            </Typography>
                        </Box>

                    </Box>

                    <Casestudyback />

                </Container>
            </Box>
        </>
    );
}